import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, message, Table } from "antd";
import { PiPlus } from "react-icons/pi";
import DashModal from "../../../Components/DashModal";
import { IMainWebsiteCategory } from "../../../types/MainWebsite";
import { Top10RichtTextDataType } from "../../Top10Articles/types";
import { getMainWebsiteByID, removeRichTextFromCategory } from "../actions";
import { CategoryRichtTextColumns } from "../types";
import AddCategoryRichText from "./AddCategoryRichText";
import EditCategoryRichText from "./EditCategoryRichText";
type Props = {
  page: number;
  pageSize: number;
  addNewRichText?: boolean;
  editRichText?: boolean;
};

const ManageCategoryRichText = (props: Props) => {
  const { page, pageSize } = props;
  const { id, categoryId } = useParams();
  const [category, setCategory] = useState<IMainWebsiteCategory | null>(null);
  const [data, setData] = useState<Top10RichtTextDataType[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const main_website = await getMainWebsiteByID(id!);
    if (main_website) {
      const cat = main_website.Categories.find((cat) => cat.id === categoryId);
      if (cat) {
        setCategory(cat);
        let items: Top10RichtTextDataType[] = [];
        cat.SortedItems.map((st) => {
          if (st.Type === "TEXT") {
            if (st.RichText) {
              items.push({
                id: st.RichText?.id,
                title: st.RichText?.Title,
              });
            }
          }
        });
        setData(items);
      }
    }

    setLoading(false);
  };

  const handleDelete = async (richtextid: string) => {
    try {
      await removeRichTextFromCategory(id!, categoryId!, richtextid);
      fetchData();
      message.success("Rich text deleted successfully");
    } catch (err) {
      message.error("Failed to delete rich text");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className=" space-y-5">
      <div className="flex justify-between items-center">
        <Link
          to={`/main-websites/manage-categories/${id}/manage-rich-text/${categoryId}/add?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<PiPlus />}>
            Add New Rich Text
          </Button>
        </Link>
      </div>

      <Table<Top10RichtTextDataType>
        rowKey="id"
        columns={CategoryRichtTextColumns(
          id!,
          categoryId!,
          page,
          pageSize,
          handleDelete
        )}
        dataSource={data}
        loading={loading}
        pagination={false}
      />

      {props.addNewRichText && (
        <DashModal
          title="Add New Rich Text"
          width={1500}
          cancleLink={`/main-websites/manage-categories/${id}/manage-rich-text/${categoryId}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <AddCategoryRichText fetchData={fetchData} />
        </DashModal>
      )}

      {props.editRichText && (
        <DashModal
          title="Edit Rich Text"
          width={1500}
          cancleLink={`/main-websites/manage-categories/${id}/manage-rich-text/${categoryId}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <EditCategoryRichText fetchData={fetchData} />
        </DashModal>
      )}
    </div>
  );
};

export default ManageCategoryRichText;
